import logo from "../../assets/img/logotipo.png";
import Carousel from "./Carousel";

// Importar imágenes del carrusel
import carouselImg1 from "../../assets/img/carrusel/1.png";
import carouselImg2 from "../../assets/img/carrusel/2.jpg";
import carouselImg3 from "../../assets/img/carrusel/3.jpg";
import carouselImg4 from "../../assets/img/carrusel/4.jpg";
import carouselImg5 from "../../assets/img/carrusel/5.jpg";

// Configuración de slides del carrusel
const getCarouselSlides = () => [
  {
    image: carouselImg1,
    alt: "Trabajadores industriales",
    showLogo: true,
    logoPosition: "top-left",
    logo: logo,
    title:
      "TE CONECTAMOS CON LA INDUSTRIA Y LÍDERES EMPRESARIALES PARA ACELERAR EL CRECIMIENTO DE TU NEGOCIO",
    subtitle:
      "Somos la única red empresarial que conecta tu empresa con oportunidades reales de la industria mexicana.",
    cta: "¡Únete y crece tus ventas!",
    ctaLink: "/contact",
  },
  {
    image: carouselImg2,
    alt: "Profesionales en reunión de negocios",
    showLogo: true,
    logoPosition: "top-right",
    logo: logo,
    title:
      "Nuestra sinergia crea una plataforma integral que ayuda a las compañías a crecer, transformarse y alcanzar su máximo valor en el mercado.",
    subtitle:
      "Somos la única red empresarial que conecta tu empresa con oportunidades reales de la industria mexicana.",
    cta: "¡Únete y crece tus ventas!",
    ctaLink: "/contact",
  },
  {
    image: carouselImg3,
    alt: "Trabajador industrial sonriente",
    showLogo: true,
    logoPosition: "top-right",
    logo: logo,
    title: "Descubre la nueva oferta de servicios para impulsar tu crecimiento",
    subtitle:
      "Somos la única red empresarial que conecta tu empresa con oportunidades reales de la industria mexicana.",
    cta: "¡Únete y crece tus ventas!",
    ctaLink: "/contact",
  },
  {
    image: carouselImg4,
    alt: "Planta industrial moderna",
    showLogo: true,
    logoPosition: "bottom-center",
    logo: logo,
    title:
      "Somos la red empresarial líder que conecta tu negocio directamente con oportunidades reales y transformadoras de la industria mexicana.",
    subtitle:
      "Accede a líderes visionarios, genera alianzas estratégicas y acelera tus ventas como nunca antes.",
    cta: "¡Únete a IBC hoy y catapulta tu crecimiento!",
    ctaLink: "/contact",
  },
  {
    image: carouselImg5,
    alt: "Tecnología e innovación industrial",
    showLogo: true,
    logoPosition: "top-right",
    logo: logo,
    title:
      "Implementamos estrategias clave que potencian la competitividad, visibilidad e innovación de tu empresa con la industria.",
    subtitle:
      "Somos la única red empresarial que conecta tu empresa con oportunidades reales de la industria mexicana.",
    cta: "¡Únete y crece tus ventas!",
    ctaLink: "/contact",
  },
];

function HeroCarousel({ autoPlayDelay = 6000 }) {
  const carouselSlides = getCarouselSlides();

  return (
    <section
      id="Hero"
      className="w-full mt-[40px] sm:mt-12 md:mt-10 lg:mt-[55px]"
    >
      <Carousel slides={carouselSlides} autoPlayDelay={autoPlayDelay} />
    </section>
  );
}

export default HeroCarousel;
